import { actionCreation } from '@anna/anna-ws-utils';

const { generateActionTypes, generateActions, makeActionCreator } = actionCreation;

export const getXeroBankAccountsActionTypes = generateActionTypes('GetXeroBankAccounts');
export const getXeroBankAccountsActions = generateActions(getXeroBankAccountsActionTypes, {
  success: [
    'accounts',
  ],
});

export const getXeroBankAccountCodesActionTypes = generateActionTypes('GetXeroBankAccountCodes');
export const getXeroBankAccountCodesActions = generateActions(
  getXeroBankAccountCodesActionTypes, {
    common: ['accountId'],
  },
);

export const getXeroBankAccountMappingsActionTypes = generateActionTypes('GetXeroBankAccountMappings');
export const getXeroBankAccountMappingsActions = generateActions(
  getXeroBankAccountMappingsActionTypes, {
    common: ['accountId'],
  },
);

export const putXeroBankAccountMappingsActionTypes = generateActionTypes('PutXeroBankAccountMappings');
export const putXeroBankAccountMappingsActions = generateActions(
  putXeroBankAccountMappingsActionTypes, {
    common: ['accountId', 'items'],
  },
);

export const setActiveXeroBankAccountsActionType = 'SetActiveXeroBankAccountsAction';
export const setActiveXeroBankAccountsAction = makeActionCreator(
  setActiveXeroBankAccountsActionType,
  ['account'],
);

export const updateXeroBankAccountMappingRecordActionType = 'UpdateXeroBankAccountMappingRecord';
export const updateXeroBankAccountMappingRecordAction = makeActionCreator(
  updateXeroBankAccountMappingRecordActionType,
  'record',
  'mapping',
);

export const resetXeroBankAccountMappingsActionType = 'ResetXeroBankAccountMappings';
export const resetXeroBankAccountMappingsAction = makeActionCreator(
  resetXeroBankAccountMappingsActionType,
);
